import { render, staticRenderFns } from "./allActiveGradeSubAct.vue?vue&type=template&id=23fa2819&scoped=true&"
import script from "./allActiveGradeSubAct.vue?vue&type=script&lang=js&"
export * from "./allActiveGradeSubAct.vue?vue&type=script&lang=js&"
import style0 from "./allActiveGradeSubAct.vue?vue&type=style&index=0&id=23fa2819&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa2819",
  null
  
)

export default component.exports